<template>
  <div class="navbar">
    <a @click="onClick('/vaults')" :class="currentRoute === '/vaults' ? 'active' : ''"><BImg :src="appLogoImage" alt="logo" class="logo"/></a>
    <a @click="onClick('/recent-contents')" :class="currentRoute === '/recent-contents' ? 'active' : ''"
      ><feather-icon icon="ClockIcon" size="24"
    /></a>
    <a @click="onClick('/favourites')" :class="currentRoute === '/favourites' ? 'active' : ''"><feather-icon icon="HeartIcon" size="24"/></a>
    <a @click="onClick('/account-setting')" :class="currentRoute === '/account-setting' ? 'active' : ''"><feather-icon icon="MenuIcon" size="24"/></a>
  </div>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import { BImg } from 'bootstrap-vue'

export default {
  components: {
    BImg
  },
  data() {
    return {
      currentRoute: ''
    }
  },
  methods: {
    onClick(route) {
      if (this.$router.currentRoute.path !== route) {
        this.$router.push(route).catch(_ => {})
      }
      this.currentRoute = route
    }
  },
  mounted() {
    this.currentRoute = this.$router.currentRoute.path
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage
    }
  }
}
</script>
<style lang="scss" scoped>
.logo {
  width: 24px;
}

/* Place the navbar at the bottom of the page, and make it stick */
.navbar {
  background-color: white;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  width: 100%;

  -webkit-box-shadow: 0px -4px 3px rgb(220 220 220 / 80%);
  -moz-box-shadow: 0px -4px 3px rgba(220, 220, 220, 0.8);
  box-shadow: 0px -4px 3px rgb(220 220 220 / 80);
}

/* Style the links inside the navigation bar */
.navbar a {
  float: left;
  display: block;
  color: #9b9a9c;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
}

/* Add a color to the active/current link */
.active {
  color: #1072ba !important;
}
</style>
